<template>
  <div class="com-box" :style="{height: isEdit ? null : pagesHeight + 'px'}">
    <div class="front" :class="{'active-front': isEdit}" ref="element">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp" >删除</div>
        </div>
        <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-topimage  :comData="value" :tmpType="tmpType"/>
    </div>
    <div class="back" :class="{'active-back': isEdit}">
      <top-image v-model="imgList" :tmpType="tmpType" />
      <div style="height: 60px;"></div>
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import previewTopimage from '@/pages/activity-home/components/top-image'
import topImage from '../../components/top-image'
import _ from 'loadsh'
export default {
  components: {
    previewTopimage,
    topImage,
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Array,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    tmpType: Number
  },
  computed: {
    ...mapGetters({
      // 经销商
      isDistributor: 'isDistributor',
      // 店长
      isShopowner: 'isShopowner',
      // 导购
      isGuide: 'isGuide',
      // 活动老师
      isTeacher: 'isTeacher',
    }),
  },
  data() {
    return {
      isEdit: false,
      formData: [],
      imgList: [],
      pagesHeight: '167',
    }
  },
  mounted() {
    // 获取组件高度
   this.$nextTick(()=> {
    let height = this.$refs.element.offsetHeight;
    this.pagesHeight = height  == '0' ? '167' : height + 20
   })
  },
  methods: {
    edit() {
      this.imgList = _.cloneDeep(this.value)
      this.isEdit = !this.isEdit
      this.$emit('handle',['topImage',false])
    },
    cancel() {
      this.isEdit = false
      this.$emit('handle', ['topImage',true])
     
    },
    save() {
      this.$emit('change', this.imgList)
      this.$nextTick(()=> {
        this.pagesHeight = this.$refs.element.offsetHeight + 20
        this.isEdit = false
        this.$emit('handle', ['topImage',true])
      })
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  }

}
</script>

<style lang="stylus" scoped>
.com-box {
  position: relative;
  perspective: 800px;
  overflow hidden
  padding: 10px 0;
  box-sizing: border-box;
  // background: blue;
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    backface-visibility: hidden;
    .head {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    margin-top: -10px;
    background: #fff;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      background: #F4F4F4;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>